import React from 'react'
import { Button, Image, Modal } from 'semantic-ui-react'
import trash_icon from '../../assets/svg/trash.svg'
import { useStateFromProp } from '../../hooks/useStateFromProps'

interface Props {
  open: boolean
  title: string
  message: string | string[]
  userInput: (action: 'cancel' | 'delete') => void
  deleteDisabled?: boolean
}

const DeleteNotAllowModal = (props: Props): JSX.Element => {
  const { open, title, message, userInput, deleteDisabled } = props
  const [_open, _setOpen] = useStateFromProp(open)

  const handleAction = (action: 'cancel' | 'delete') => {
    _setOpen(false)
    userInput(action)
  }

  const renderMsgs = () => {
    if (typeof message === 'string') {
      return <p style={{ margin: 0 }}>{message}</p>
    } else {
      return <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
        {message.map(m => <p style={{ margin: 0 }}>{m}</p>)}
      </div>
    }
  }

  return (
    <Modal
      size='tiny'
      open={_open}
      closeOnDimmerClick={false}
      onClose={() => _setOpen(false)}
      onOpen={() => _setOpen(true)}
    >
      <Modal.Header style={{ fontSize: '1.8rem', display: 'flex', justifyContent: 'center', flexDirection: 'column', fontWeight: 500, textAlign: 'center' }}>
        <Image src={trash_icon} style={{ height: '3.5rem', marginBottom: '1rem' }} />
        <p>{title}</p>
      </Modal.Header>
      <Modal.Content style={{ fontSize: '1.1rem', padding: '0rem 3rem 0 3rem', textAlign: 'center' }}>
        <Modal.Description style={{ display: 'flex', flexDirection: 'column' }}>
          {renderMsgs()}
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions style={{ display: 'flex', justifyContent: 'center' }}>
        <Button style={{ borderRadius: '5px' }} onClick={() => handleAction('cancel')} content='Close' />
        {deleteDisabled && <Button disabled={true} style={{ borderRadius: '5px' }} color={'red'} onClick={() => handleAction('delete')} content='Delete' />}
      </Modal.Actions>
    </Modal>
  )
}

export default DeleteNotAllowModal
